import DapDSModal from './modal.component'

export * from './modal.component'
export default DapDSModal

DapDSModal.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-modal': DapDSModal
  }
}
